// Thanks to https://github.com/WeiChiaChang/easter-egg-collection
// Type 'bbtmeme' on your keyboard to start

const key = [66, 66, 84, 77, 69, 77, 69];
let counter = 0;
const max = key.length;

function record(e) {
  if (e.which === key[counter]) {
    counter += 1;
  } else {
    counter = 0;
  }

  if (counter >= max) {
    const script = document.createElement('script');
    script.src = 'https://rawgit.com/WeiChiaChang/Easter-egg/master/easter-eggs-collection.js';
    script.onload = () => {
      const shock = document.createElement('div');
      const img = new Image();
      img.src = 'https://media2.giphy.com/media/jU397nUOKJjqNLneYG/giphy.gif?cid=790b76115ce7fec73265666e363993ae&rid=giphy.gif';
      img.style.pointerEvents = 'none';
      img.style.transition = '1s all';
      img.style.width = '200px';
      img.style.height = '200px';
      img.style.position = 'fixed';
      img.style.left = 'calc(50% - 300px)';
      img.style.bottom = '50%';
      img.style.opacity = 0;
      img.style.zIndex = 999999;

      document.body.appendChild(img);

      window.setTimeout(() => {
        img.style.opacity = 1;
      }, 30);

      window.setTimeout(() => {
        img.style.opacity = 1;
      }, 2300);

      window.setTimeout(() => {
        img.parentNode.removeChild(img);
        shock.parentNode.removeChild(shock);
      }, 3400);
    };

    document.head.appendChild(script);
    document.removeEventListener('keyup', this);
  }
}

function init() {
  document.addEventListener('keyup', record);
}

init();
